import EUserType from 'enums/userTypes';

import { ReduxStore } from 'store/types';

function userRole(state: ReduxStore): EUserType | undefined {
  return state.auth.profile.role;
}

export default userRole;
